import customAxios from "./axiosConfig";

const ProfileService = {
    list: function (params) {
        var url = window.Urls["profile-list"]();
        return customAxios.get(url, {params: params});
    },
    update: function (id, data) {
        const config = {
            headers: {'content-type': 'application/json;charset=UTF-8'},
        };
        var url = window.Urls['profile-detail'](id);
        return customAxios.put(url, data, config);
    },
    getCurrent: function () {
        var url = window.Urls["profile_get_current"]();
        return customAxios.get(url);
    },
    toggleSmartScan: function() {
        var url = window.Urls["profile_toggle_smart_scan"]();
        return customAxios.get(url);
    }
};

export default ProfileService;